module.exports = __webpack_public_path__ + "img/mo.de26729c.svg";